import(/* webpackMode: "eager", webpackExports: ["DonatePageContent"] */ "/opt/build/repo/src/app/(site)/[streamer]/[wishSlug]/components/content.tsx");
